"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countBy = exports.partition = exports.groupByProperty = exports.groupByMany = exports.groupBy = exports.minByProperty = exports.minBy = exports.min = exports.maxByProperty = exports.maxBy = exports.max = exports.sumByProperty = exports.sumBy = exports.sum = exports.get = exports.byProperty = exports.byValue = exports.by = exports.propertyIsntOneOf = exports.isntOneOfBy = exports.isntOneOf = exports.excludeByProperty = exports.excludeBy = exports.exclude = exports.propertyIsOneOf = exports.isOneOfBy = exports.isOneOf = exports.intersectionByProperty = exports.intersectionBy = exports.intersection = exports.has = exports.propertyIsnt = exports.isntBy = exports.isnt = exports.propertyIs = exports.isBy = exports.is = exports.uniqueByProperty = exports.unique = exports.uniqueBy = exports.duplicatesByProperty = exports.duplicates = exports.duplicatesBy = exports.or = exports.isDefined = void 0;
var isDefined = function (x) {
    return x !== undefined && x !== null;
};
exports.isDefined = isDefined;
var or = function (fallback) { return function (x) {
    return exports.isDefined(x) ? x : fallback;
}; };
exports.or = or;
var findIndex = function (list, pred) {
    for (var i = 0; i < list.length; i++) {
        if (pred(list[i]))
            return i;
    }
    return -1;
};
var duplicatesBy = function (func) { return function (el, _, list) {
    var n = 0;
    for (var i = 0; i < list.length; i++) {
        if (n >= 2)
            return true;
        if (func(list[i]) === func(el))
            n++;
    }
    return false;
}; };
exports.duplicatesBy = duplicatesBy;
exports.duplicates = exports.duplicatesBy(function (el) { return el; });
var duplicatesByProperty = function (key) { return exports.duplicatesBy(get(key)); };
exports.duplicatesByProperty = duplicatesByProperty;
var uniqueBy = function (func) { return function (el, index, list) { return index === findIndex(list, function (t) { return func(t) === func(el); }); }; };
exports.uniqueBy = uniqueBy;
exports.unique = exports.uniqueBy(function (el) { return el; });
var uniqueByProperty = function (key) { return exports.uniqueBy(get(key)); };
exports.uniqueByProperty = uniqueByProperty;
var is = function (value) { return function (el) { return el === value; }; };
exports.is = is;
var isBy = function (func, value) { return function (el) {
    return func(el) === value;
}; };
exports.isBy = isBy;
var propertyIs = function (key, value) { return exports.isBy(get(key), value); };
exports.propertyIs = propertyIs;
var isnt = function (value) { return function (el) { return el !== value; }; };
exports.isnt = isnt;
var isntBy = function (func, value) { return function (el) {
    return func(el) !== value;
}; };
exports.isntBy = isntBy;
var propertyIsnt = function (key, value) { return exports.isntBy(get(key), value); };
exports.propertyIsnt = propertyIsnt;
var has = function () {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    return function (object) {
        return keys.every(function (key) { return exports.isDefined(object[key]); });
    };
};
exports.has = has;
var intersection = function (list) { return function (el) {
    return findIndex(list, function (a) { return a === el; }) !== -1;
}; };
exports.intersection = intersection;
var intersectionBy = function (func, list) { return function (el) { return findIndex(list, function (a) { return func(a) === func(el); }) !== -1; }; };
exports.intersectionBy = intersectionBy;
var intersectionByProperty = function (key, list) { return exports.intersectionBy(get(key), list); };
exports.intersectionByProperty = intersectionByProperty;
exports.isOneOf = exports.intersection;
var isOneOfBy = function (func, list) { return function (el) {
    return findIndex(list, function (a) { return a === func(el); }) !== -1;
}; };
exports.isOneOfBy = isOneOfBy;
var propertyIsOneOf = function (key, list) { return exports.isOneOfBy(get(key), list); };
exports.propertyIsOneOf = propertyIsOneOf;
var exclude = function (list) { return function (el) {
    return findIndex(list, function (a) { return a === el; }) === -1;
}; };
exports.exclude = exclude;
var excludeBy = function (func, list) { return function (el) {
    return findIndex(list, function (a) { return func(a) === func(el); }) === -1;
}; };
exports.excludeBy = excludeBy;
var excludeByProperty = function (key, list) { return exports.excludeBy(get(key), list); };
exports.excludeByProperty = excludeByProperty;
exports.isntOneOf = exports.exclude;
var isntOneOfBy = function (func, list) { return function (el) {
    return findIndex(list, function (a) { return a === func(el); }) === -1;
}; };
exports.isntOneOfBy = isntOneOfBy;
var propertyIsntOneOf = function (key, list) { return exports.isntOneOfBy(get(key), list); };
exports.propertyIsntOneOf = propertyIsntOneOf;
var by = function (func) { return function (a, b) {
    var A = func(a), B = func(b);
    if (typeof A === "boolean")
        return A && !B ? -1 : !A && B ? 1 : 0;
    return A < B ? -1 : A > B ? 1 : 0;
}; };
exports.by = by;
var byValue = function (a, b) { return (a < b ? -1 : a > b ? 1 : 0); };
exports.byValue = byValue;
var byProperty = function (key) { return exports.by(get(key)); };
exports.byProperty = byProperty;
function get(key1, key2, key3) {
    return function (obj) {
        if (key3 && key2)
            return obj && obj[key1] && obj[key1][key2] && obj[key1][key2][key3];
        if (key2)
            return obj && obj[key1] && obj[key1][key2];
        return obj && obj[key1];
    };
}
exports.get = get;
var sum = function (acc, element) { return acc + element; };
exports.sum = sum;
function sumBy(func) {
    return function (acc, el) {
        return typeof el === "number" ? func(acc) + func(el) : acc + func(el);
    };
}
exports.sumBy = sumBy;
var sumByProperty = function (key) { return function (acc, el) { return acc + el[key]; }; };
exports.sumByProperty = sumByProperty;
var max = function (acc, el) { return Math.max(acc, el); };
exports.max = max;
var maxBy = function (func) { return function (acc, el) {
    return func(el) > func(acc) ? el : acc;
}; };
exports.maxBy = maxBy;
var maxByProperty = function (key) { return function (acc, el) { return (el[key] > acc[key] ? el : acc); }; };
exports.maxByProperty = maxByProperty;
var min = function (acc, el) { return Math.min(acc, el); };
exports.min = min;
var minBy = function (func) { return function (acc, el) {
    return func(el) < func(acc) ? el : acc;
}; };
exports.minBy = minBy;
var minByProperty = function (key) { return function (acc, el) { return (el[key] < acc[key] ? el : acc); }; };
exports.minByProperty = minByProperty;
var groupBy = function (func) { return function (acc, el) {
    var groupName = func(el);
    if (!groupName)
        return acc;
    if (!acc[groupName])
        acc[groupName] = [];
    acc[groupName].push(el);
    return acc;
}; };
exports.groupBy = groupBy;
var groupByMany = function (func) { return function (acc, el) {
    var groupNames = func(el) || [];
    groupNames.forEach(function (key) {
        if (!acc[key])
            acc[key] = [];
        acc[key].push(el);
    });
    return acc;
}; };
exports.groupByMany = groupByMany;
var groupByProperty = function (key) { return function (acc, el) {
    var groupName = el[key];
    if (!groupName)
        return acc;
    if (!acc[groupName])
        acc[groupName] = [];
    acc[groupName].push(el);
    return acc;
}; };
exports.groupByProperty = groupByProperty;
var partition = function (func) { return function (acc, el) {
    var a0 = acc[0] || [], a1 = acc[1] || [];
    if (func(el))
        a0.push(el);
    else
        a1.push(el);
    return [a0, a1];
}; };
exports.partition = partition;
var countBy = function (func) { return function (acc, el) {
    return acc + (func(el) ? 1 : 0);
}; };
exports.countBy = countBy;
